import React from "react";
import "./Card.css";

const Card = ({emoji, heading, detail, color}) => {
  return (
    <div className="card" style={{borderColor: {color}}}> 
      <img src={emoji} alt="" />
      <span>{heading}</span>
      <span>{detail}</span>
      <a target="_blank" href="https://www.github.com/francedermaz">
        <button class="c-button">LEARN MORE</button>
      </a>
    </div>
  );
};

export default Card;
